import {
  Modal,
  Pressable,
  StyleSheet,
  View,
  useWindowDimensions,
} from "react-native";
import { BlurView } from "expo-blur";
import { Avatar } from "@/shared/components/ui/avatar";

type AvatarPreviewModalProps = {
  visible: boolean;
  onClose: () => void;
  url?: string | null;
  name?: string | null;
};

export function AvatarPreviewModal({
  visible,
  onClose,
  url,
  name,
}: AvatarPreviewModalProps) {
  const { width } = useWindowDimensions();
  const size = Math.min(width - 48, 360);

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <Pressable
        className="flex-1 items-center justify-center"
        onPress={onClose}
        accessibilityLabel="Fechar visualização da foto"
      >
        <BlurView
          intensity={15}
          tint="dark"
          style={StyleSheet.absoluteFill}
          pointerEvents="none"
        >
          <View className="flex-1 bg-black/30" />
        </BlurView>

        <Avatar url={url} name={name} size={size} />
      </Pressable>
    </Modal>
  );
}
